import {tokenUtility} from "../../../data-access/src";
import {
  exitWebview,
  isAndroid,
  baseUrl,
  hasNotify,
} from "@maya/helper/ui-shared";
import {createBrowserHistory} from "history";

declare const window: any;
const {gapi} = window as any;

export const isTokenExpired = (token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c: string) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join(""),
  );
  const tokenObj: {exp: number} = JSON.parse(jsonPayload);
  return !!(tokenObj.exp && new Date() > new Date(tokenObj.exp * 1000));
};

export function getIdToken() {
  //TODO:update this logic

  if (tokenUtility().getStoredToken()) {
    return tokenUtility().getStoredToken();
  }
  if (window.externalAuthToken) {
    return window.externalAuthToken;
  }
  return null;
}

export function isTokenLogin() {
  return (
    (window as any).externalAuthToken ||
    (window.localStorage && window.localStorage.getItem("token"))
  );
}

export function setAccessToken(token: string) {
  (window as any).externalAuthToken = token;
}

export function tokenLogin(token: string) {
  (window as any).externalAuthToken = token;
  if (window.localStorage) {
    window.localStorage.setItem("token", token);
  }
}

export const setAndroidVersion = (apiVersion: number) => {
  (window as any).androidApiVersion = apiVersion;
  if (window.localStorage) {
    window.localStorage.setItem("apiVersion", apiVersion);
  }
};

export function tryTokenLogin() {
  const queryParams = createBrowserHistory().location.hash.split("?");
  if (queryParams.length > 1) {
    const idToken = new URLSearchParams(queryParams[1]).get("id_token");
    const apiVersion = new URLSearchParams(queryParams[1]).get("apiVersion");
    if (idToken) {
      tokenLogin(decodeURIComponent(idToken));
    }
    if (apiVersion) {
      setAndroidVersion(Number(apiVersion));
    }
  }
}

export const clearAuthToken = () => {
  window.localStorage.removeItem("token");
  window.externalAuthToken = undefined;
};

export const getAndroidApiVersion = (): number | null => {
  if (window.androidApiVersion) {
    return window.androidApiVersion;
  }
  if (window.localStorage && window.localStorage.getItem("apiVersion")) {
    return window.localStorage.getItem("apiVersion");
  }
  return null;
};

export function headers() {
  const idToken = getIdToken();
  return {Authorization: `Bearer ${idToken}`};
}

const getUserAgent = (): {
  header: string;
  platform?: string;
  appVersionCode?: number;
} => {
  let userAgent = {
    header: "",
    platform: undefined,
    appVersionCode: undefined,
  };
  try {
    userAgent = JSON.parse(navigator.userAgent);
  } catch (error) {
    userAgent.header = navigator.userAgent.toLowerCase();
  }
  return userAgent;
};

export const isNativeAndroid = () => {
  const userAgent = getUserAgent();

  if (userAgent?.platform === "android") return true;
  return false;
};

export const isWebview = () => {
  const standalone = window.navigator.standalone;
  const userAgent = getUserAgent().header;
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  if (userAgent.includes("wv") || (ios && !standalone && !safari)) {
    return true;
  } else {
    return false;
  }
};

export const isMobileOrTab = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => {
    return getUserAgent().header.match(toMatchItem);
  });
};

export const getAppLoginURL = () => {
  if (isAndroid()) {
    exitWebview();
  }
  if (window.location.origin.includes("localhost")) {
    return `${window.location.origin}/#/`;
  }
  return `${baseUrl}/apply/#${window.location.pathname}`;
};
